export default __webpack_public_path__ + "static/media/pay_success.4c2c0850.png";